import { Inject, Injectable } from '@angular/core';
import { DOCUMENT_STATUS_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { DocumentsLogicService } from '@app/logic/documents';
import { IDocumentEntityMappedItem } from '@app/logic/documents/interfaces/i.document.mapped';
import { IPdfViewerDialogItem } from '@app/shared/components/pdf-viewer/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { PdfViewerDialogService } from '@app/shared/components/pdf-viewer/pdf-viewer-dialog/pdf-viewer-dialog.service';

export function isDocumentEntityInactive(documentEntity: IDocumentEntityMappedItem): boolean {
    return (
        !!documentEntity.document?.isDeleted ||
        documentEntity.documentStatus === DOCUMENT_STATUS_ENUM.StubDeleted ||
        documentEntity.documentStatus === DOCUMENT_STATUS_ENUM.Cancelled
    );
}

@Injectable({
    providedIn: 'root'
})
export class DocumentPdfViewerService {
    constructor(
        private readonly pdfViewerDialog: PdfViewerDialogService,
        @Inject(DocumentsLogicService) private readonly documentsLogicService: DocumentsLogicService
    ) {}

    public canView(documentEntity: IDocumentEntityMappedItem): boolean {
        return (
            !!documentEntity?.document?.id &&
            !isDocumentEntityInactive(documentEntity) &&
            (documentEntity.document.filename ?? '').toLowerCase().endsWith('.pdf')
        );
    }

    /** Items are keyed by the entity id: linked documents can put the same document into several entities */
    public open(documentEntities: IDocumentEntityMappedItem[], selectedEntityId: number): void {
        const viewableEntities = documentEntities.filter(documentEntity =>
            this.canView(documentEntity)
        );
        const documentIdsByEntityId = new Map(
            viewableEntities.map(documentEntity => [documentEntity.id, documentEntity.document.id])
        );
        const items: IPdfViewerDialogItem[] = viewableEntities.map(documentEntity => ({
            id: documentEntity.id,
            name: documentEntity.document.name || documentEntity.document.filename,
            filename: documentEntity.document.filename,
            documentType: documentEntity.documentType?.label,
            groupId: documentEntity.documentGroup?.id,
            groupName: documentEntity.documentGroup?.name
        }));

        this.pdfViewerDialog.open({
            items,
            selectedItemId: selectedEntityId,
            loadPdf: (entityId: number) =>
                this.documentsLogicService.getPdfBlob(documentIdsByEntityId.get(entityId))
        });
    }
}
